var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScikitlearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "scikit-learn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 26,
    r: 18,
    fill: "#f7931e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 40,
    r: 16,
    fill: "#3499cd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 38a16 16 0 0 1 10.3-14A18 18 0 0 1 42 26a18 18 0 0 1-11 16.6z",
    fill: "#fff",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScikitlearn);
export default __webpack_public_path__ + "static/media/scikitlearn.d1305cc0b6b2c2b7a44aae2cf3161b8c.svg";
export { ForwardRef as ReactComponent };